'use client';

import { FC } from 'react';
import { useRouter } from 'next/navigation';

import IconButton from '@mui/material/IconButton';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { Box, Stack, Container, Typography } from '@mui/material';

import { useLocales } from '../../../../locales';
import Iconify from '../../../../components/iconify';
import { ComponentTypeProps } from '../../../../types/page-generator';

const CryptoNotifications: FC<ComponentTypeProps> = ({ block }) => {
  const { currentLang } = useLocales();
  const router = useRouter();

  const notifications = [
    {
      id: 1,
      icon: 'tdesign:notification',
      title: 'Two-Factor Authentication-2FA Update',
    },
    {
      id: 2,
      icon: 'tdesign:notification',
      title: 'Holiday Notice- Good Friday',
    },
    {
      id: 3,
      icon: 'tdesign:notification',
      title: 'Introduction of Monthly Subscription Fees',
    },
    {
      id: 4,
      icon: 'tdesign:notification',
      title: 'Introduction of Monthly Subscription Fee',
    },
    {
      id: 5,
      icon: 'tdesign:notification',
      title: 'PT Card Balance Transfer to Crypto Wallet for Harel Gobani',
    },
    {
      id: 6,
      icon: 'tdesign:notification',
      title: 'New Card Application Details',
    },
    {
      id: 7,
      icon: 'tdesign:notification',
      title: 'System Upgrade Notice',
    },
    {
      id: 8,
      icon: 'fluent:tv-usb-48-regular',
      title: 'Online Payment',
      subtitle: 'Your Withdraw of 36.80 USD has been successfully processed',
      date: 'Feb 27, 2025 at 07:17 AM',
    },
    {
      id: 9,
      icon: 'fluent:tv-usb-48-regular',
      title: 'Online Payment',
      subtitle: 'Your Withdraw of 2.07 USD has been successfully processed',
      date: 'Feb 27, 2025 at 07:17 AM',
    },
  ];

  return (
    <Container maxWidth="sm" sx={{ p: 0 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 3,
          flexDirection: currentLang.value === 'he' ? 'row-reverse' : 'row',
        }}
      >
        <IconButton color="inherit" onClick={() => router.back()}>
          <ArrowBack sx={{ color: 'black' }} />
        </IconButton>
        <Typography variant="h6" sx={{ color: 'black' }}>
          Notifications
        </Typography>
      </Box>

      <Stack spacing={2}>
        {notifications.map((n) => (
          <Box
            key={n.id}
            sx={{
              display: 'flex',
              gap: 2,
              alignItems: 'flex-start',
              bgcolor: '#40334A',
              borderRadius: 2,
              px: 2,
              py: 2,
              cursor: 'pointer',
            }}
          >
            <Box
              sx={{
                bgcolor: '#1F1F1F',
                borderRadius: '50%',
                width: 40,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mt: '4px',
              }}
            >
              <Iconify icon={n.icon} sx={{ color: 'white', fontSize: 20 }} />
            </Box>

            <Box sx={{ flex: 1 }}>
              <Stack direction="row" width={1} justifyContent="space-between" alignItems="center">
                <Typography sx={{ color: 'white', fontWeight: 600, fontSize: 14 }}>
                  {n.title}
                </Typography>
                {n.date && (
                  <Typography sx={{ color: '#8D8D8D', fontSize: 12 }}>{n.date}</Typography>
                )}
              </Stack>
              {n.subtitle && (
                <Typography sx={{ color: '#B5B5B5', fontSize: 13, mt: 0.5 }}>
                  {n.subtitle}
                </Typography>
              )}
            </Box>
          </Box>
        ))}
      </Stack>
    </Container>
  );
};
export default CryptoNotifications;
